/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { productsControllerCreateProduct } from '../fn/products/products-controller-create-product';
import { ProductsControllerCreateProduct$Params } from '../fn/products/products-controller-create-product';
import { productsControllerDeleteProduct } from '../fn/products/products-controller-delete-product';
import { ProductsControllerDeleteProduct$Params } from '../fn/products/products-controller-delete-product';
import { productsControllerGetProduct } from '../fn/products/products-controller-get-product';
import { ProductsControllerGetProduct$Params } from '../fn/products/products-controller-get-product';
import { productsControllerGetProducts } from '../fn/products/products-controller-get-products';
import { ProductsControllerGetProducts$Params } from '../fn/products/products-controller-get-products';
import { productsControllerUpdateProduct } from '../fn/products/products-controller-update-product';
import { ProductsControllerUpdateProduct$Params } from '../fn/products/products-controller-update-product';

@Injectable({ providedIn: 'root' })
export class ProductsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `productsControllerGetProducts()` */
  static readonly ProductsControllerGetProductsPath = '/keus-payments/products';

  /**
   * Get all products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productsControllerGetProducts()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsControllerGetProducts$Response(params: ProductsControllerGetProducts$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return productsControllerGetProducts(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all products.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productsControllerGetProducts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsControllerGetProducts(params: ProductsControllerGetProducts$Params, context?: HttpContext): Observable<void> {
    return this.productsControllerGetProducts$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `productsControllerCreateProduct()` */
  static readonly ProductsControllerCreateProductPath = '/keus-payments/products';

  /**
   * Create a new product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productsControllerCreateProduct()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productsControllerCreateProduct$Response(params: ProductsControllerCreateProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return productsControllerCreateProduct(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new product.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productsControllerCreateProduct$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productsControllerCreateProduct(params: ProductsControllerCreateProduct$Params, context?: HttpContext): Observable<void> {
    return this.productsControllerCreateProduct$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `productsControllerGetProduct()` */
  static readonly ProductsControllerGetProductPath = '/keus-payments/products/{productId}';

  /**
   * Get a product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productsControllerGetProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsControllerGetProduct$Response(params: ProductsControllerGetProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return productsControllerGetProduct(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a product.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productsControllerGetProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsControllerGetProduct(params: ProductsControllerGetProduct$Params, context?: HttpContext): Observable<void> {
    return this.productsControllerGetProduct$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `productsControllerUpdateProduct()` */
  static readonly ProductsControllerUpdateProductPath = '/keus-payments/products/{productId}';

  /**
   * Update a product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productsControllerUpdateProduct()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productsControllerUpdateProduct$Response(params: ProductsControllerUpdateProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return productsControllerUpdateProduct(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a product.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productsControllerUpdateProduct$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productsControllerUpdateProduct(params: ProductsControllerUpdateProduct$Params, context?: HttpContext): Observable<void> {
    return this.productsControllerUpdateProduct$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `productsControllerDeleteProduct()` */
  static readonly ProductsControllerDeleteProductPath = '/keus-payments/products/product/{productId}';

  /**
   * Delete a product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productsControllerDeleteProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsControllerDeleteProduct$Response(params: ProductsControllerDeleteProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return productsControllerDeleteProduct(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a product.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productsControllerDeleteProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productsControllerDeleteProduct(params: ProductsControllerDeleteProduct$Params, context?: HttpContext): Observable<void> {
    return this.productsControllerDeleteProduct$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
